<ce-breadcrumb
    [breadcrumbRoutes]="[{ title: 'Notifications', path: notificationListUrl }]"
    class="u-hide-gt-sm"
/>
@if (notificationIsFound() !== false) {
    <ce-template-view-header
        [heading]="notification().title"
        [backRouterLink]="notificationListUrl"
        [hasLoaded]="hasLoaded()"
    >
        <div view-header-slot="actions">
            <button
                type="button"
                ce-button
                ce-button-small
                ce-button-type-tertiary
                [ceContextMenuTriggerFor]="actions"
                [ceContextMenuPosition]="'bottom-right'"
            >
                Actions
                <ce-icon svgIcon="more" suffix-icon ce-icon-sm />
            </button>

            <ce-context-menu #actions>
                <ce-list size="sm">
                    @if (isVehicleTelematicsNotification()) {
                        <a
                            [routerLink]="detailsUrl"
                            class="u-color-text-primary u-text-decoration-none"
                        >
                            <ce-list-option>
                                <ce-icon ce-list-option-prefix svgIcon="calendar" ce-icon-sm />
                                <span ce-list-option-title>{{ linkToClassicLabel }}</span>
                            </ce-list-option>
                        </a>
                    }
                    @if (detailsRouterLink) {
                        <a
                            [routerLink]="detailsRouterLink"
                            [queryParams]="detailsQueryParams"
                            class="u-color-text-primary u-text-decoration-none"
                        >
                            <ce-list-option>
                                <ce-icon ce-list-option-prefix svgIcon="calendar" ce-icon-sm />
                                <span ce-list-option-title>{{ linkLabel }}</span>
                            </ce-list-option>
                        </a>
                    }
                    @if (showClassicLink()) {
                        <a
                            [href]="detailsInClassicUrl"
                            target="_blank"
                            [ceTooltip]="tooltipText()"
                            ceTooltipPosition="right"
                            class="u-color-text-primary u-text-decoration-none"
                        >
                            <ce-list-option>
                                <ce-icon ce-list-option-prefix svgIcon="calendar" ce-icon-sm />
                                <span ce-list-option-title>{{ linkToClassicLabel }}</span>
                                <ce-icon
                                    ce-list-option-suffix
                                    svgIcon="new-tab"
                                    ce-icon-sm
                                    class="u-color-elements-tertiary"
                                />
                            </ce-list-option>
                        </a>
                    }
                    @if (notification().status === 'read') {
                        <button type="button" (click)="updateReadStatus(false)" class="ce-button-bare">
                            <ce-list-option>
                                <ce-icon ce-list-option-prefix svgIcon="envelope-unread" ce-icon-sm />
                                Mark as unread
                            </ce-list-option>
                        </button>
                    } @else {
                        <button type="button" (click)="updateReadStatus(true)" class="ce-button-bare">
                            <ce-list-option>
                                <ce-icon ce-list-option-prefix svgIcon="envelope" ce-icon-sm />
                                Mark as read
                            </ce-list-option>
                        </button>
                    }
                    <ce-list-option
                        [routerLink]="'/profile-settings/notification-settings/' + notification().eventType"
                    >
                        <ce-icon ce-list-option-prefix svgIcon="settings" ce-icon-sm />
                        Go to notification settings
                    </ce-list-option>
                    @if (notification().archived) {
                        <button type="button" (click)="updateArchivedStatus(false)" class="ce-button-bare">
                            <ce-list-option>
                                <ce-icon ce-list-option-prefix svgIcon="unarchive" ce-icon-sm />
                                Unarchive
                            </ce-list-option>
                        </button>
                    } @else {
                        <button type="button" (click)="updateArchivedStatus(true)" class="ce-button-bare">
                            <ce-list-option>
                                <ce-icon ce-list-option-prefix svgIcon="archive" ce-icon-sm />
                                Archive
                            </ce-list-option>
                        </button>
                    }
                </ce-list>
            </ce-context-menu>
        </div>
    </ce-template-view-header>
}
@if (hasLoaded()) {
    @if (notificationIsFound() === true) {
        <div
            class="Notification u-border-radius-md u-border-secondary u-color-background-primary u-spacing-xl-pa u-spacing-lg-mb"
        >
            @if (isPmcFaultEvent()) {
                <ce-notification-pmc-fault-content
                    [notification]="notification()"
                    [emailTimestamp]="emailTimestamp()"
                    [detailsInClassicUrl]="detailsInClassicUrl"
                    [tooltipText]="tooltipText()"
                    [linkLabel]="linkToClassicLabel"
                />
            }
            @if (isSystemEvent()) {
                <ce-notification-subscription-about-to-expire-content
                    [notification]="notification()"
                    [emailTimestamp]="emailTimestamp()"
                    [detailsInClassicUrl]="detailsInClassicUrl"
                    [linkLabel]="linkToClassicLabel"
                />
            }
            @if (isVehicleTelematicsNotification()) {
                <ce-notification-vehicle-telematics-content
                    [notification]="notification()"
                    [emailTimestamp]="emailTimestamp()"
                    [detailsUrl]="detailsUrl"
                    [linkLabel]="linkToClassicLabel"
                />
            }
            @if (isDepotOperationEvent() && !isVehicleTelematicsNotification()) {
                <ce-notification-depot-operation-content
                    [notification]="notification()"
                    [emailTimestamp]="emailTimestamp()"
                    [detailsRouterLink]="detailsRouterLink"
                    [detailsQueryParams]="detailsQueryParams"
                    [tooltipText]="tooltipText()"
                    [linkLabel]="linkLabel"
                />
            }
        </div>
    } @else if (notificationIsFound() === false) {
        <ce-empty-state type="empty" size="md">
            <h1 ce-empty-state-title>Notification not found</h1>
            <p ce-empty-state-description>
                This notification may belong to a different organization than the one you're currently logged into, the
                link may be broken, or the notification may no longer be available. Notifications are only retained for
                90 days.
            </p>
        </ce-empty-state>
    }
} @else {
    <ce-skeleton-loader class="u-size-11xl-h" />
}
